import { GET } from "../../API/get";

export const loadData = async (page_number, sort_key, sort_direction, start_date, end_date, serach_text, dispatch) => {
    dispatch({ type: "IS_LOADING" });

    let url = `/ftms/revenue/${page_number}?search=${serach_text.trim()}&sort_key=${sort_key}&sort_direction=${sort_direction}`;

    if(start_date && end_date) {
        url += `&start_date=${start_date}&end_date=${end_date}`;
    }
    
    let response = await GET(url);

    if(response.status === "Success"){
        dispatch({ 
            type: "IS_LOADED",
            total_ftms: response.total_ftms,
            total_pages: response.total_pages,
            list: response.list,
            page_number: page_number
        });
    }
}

export const filterDate = (data, reset, dispatch) => {
    if(data.start_date === '' && data.end_date === ''){
        dispatch({
            type: "SET_ERROR",
            error: 'Please select start date and end date.'
        });
    }else{
        if(data.start_date === ''){
            dispatch({
                type: "SET_ERROR",
                error: 'Please select start date.'
            });
        }else{
            if(data.end_date === ''){
                dispatch({
                    type: "SET_ERROR",
                    error: 'Please select end date.'
                });
            }else{
                dispatch({
                    type: "SET_ERROR",
                    error: null
                });
                reset();
                dispatch({
                    type: 'SET_DATE_RANGE',
                    start_date: data.start_date,
                    end_date: data.end_date
                });
            }
        }
    }
}